/**
 * @generated SignedSource<<3984cf7d8416a07f061aa52524b1a72d>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NavBarUserMenu_query$data = {
  readonly platform: {
    readonly " $fragmentSpreads": FragmentRefs<"AppVersion_version">;
  };
  readonly whoami: {
    readonly displayName: string | null | undefined;
  };
  readonly " $fragmentSpreads": FragmentRefs<"PreferencesDialog_query">;
  readonly " $fragmentType": "NavBarUserMenu_query";
};
export type NavBarUserMenu_query$key = {
  readonly " $data"?: NavBarUserMenu_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"NavBarUserMenu_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NavBarUserMenu_query",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Platform",
      "kind": "LinkedField",
      "name": "platform",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "AppVersion_version"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CurrentUser",
      "kind": "LinkedField",
      "name": "whoami",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "displayName",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PreferencesDialog_query"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "67cab2e685bd3d0df0ef33694e4ce122";

export default node;
